import React, { useContext, useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceColors } from "./helpers/PlaceColors";
import { IconShadow } from "./helpers/DefaultShadows";
import { BaseFindifyList } from "./components/FindifyList";
import { FindifySimpleHeader } from "./components/FindifySimpleHeader";
import { getApiFromModule } from "./helpers/GetContentsByModule";
import { getTranslatedString } from "./helpers/FindifyTranslatedString";
import { EventsListItemLine } from "../events/PlaceTab";
import { useTranslation } from "react-i18next";

export const TicketsListZonePage = ({ navigation, ...props }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [validEvents, setValidEvents] = useState<any[]>([]);
    const [ticketCollections, setTicketCollections] = useState<any[]>([]);
    const { t } = useTranslation();

    useEffect(() => {
        getApiFromModule('tickets_collections', findifyDataContext).getList(0, 1000, null, {
            event_id_not: 'null'
        }, null).then((res) => {
            const ticketCollections = res.results;
            const events_ids = Array.from(new Set(ticketCollections.map((ticketCollection: any) => ticketCollection.event_id)));

            getApiFromModule('events', findifyDataContext).getList(0, events_ids.length, null, {
                event_id_in: JSON.stringify(events_ids), //events_ids
            }, null).then((res) => {
                const events = res.results;
                setTicketCollections(ticketCollections);
                setValidEvents(events);
            });
        })
    }, []);


    // Load events from api
    return <View>
        <View
            style={{
                width: '100%',
                height: '100%',
                backgroundColor: PlaceColors(findifyDataContext).background.get(),
            }}
        >
            <BaseFindifyList
                enableGrid={false}
                renderLine={(item: any, index: number) => EventsListItemLine(
                    1,
                    item,
                    index,
                    findifyDataContext,
                    validEvents.length,
                )}
                items={
                    validEvents.map((item: any) => {
                        return {
                            ...item,
                            id: item.workspace_id,
                            image: item?.app_settings?.app_logo_url,
                            title: getTranslatedString(item.name, findifyDataContext),
                            onPress: () => {
                                navigation.navigate('PlaceContentDetails', {
                                    module: 'events',
                                    content_id: item.event_id,
                                    page_slug: item.page_slug
                                });

                                // selectWorkspace(item, findifyDataContext);
                            }
                        };
                    })
                }
                header={<FindifySimpleHeader
                    navigation={navigation}
                    title={
                        "teste"
                    }
                    actions={undefined}
                    image={undefined} />}
                keyExtractor={(item, index) => index.toString()}
                selectLabel={t('list.read_more')}
                actions={undefined}

            />
            {/* <PlaceText>Torresmo</PlaceText> */}
        </View>
    </View>;
};


const styles = StyleSheet.create({
    headerIcon: {
        padding: 5,
        ...IconShadow
    }
});